// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

* {
  font-family: "Montserrat", sans-serif !important;
}

body {
  -webkit-font-smoothing: antialiased;
}

h3 {
  margin-top: 15px;
}

hr {
  height: 1px;
  background: #444343;
  border: none;
}

label {
  display: flex !important;
  flex-direction: row !important;
  font-weight: 600;
  margin-top: 20px;
}

.in-row-label {
  justify-content: flex-start;
  margin-right: 15px;
  white-space: nowrap;
}
.in-row-label select {
  margin-left: 10px;
  margin-top: -5px;
  width: 240px;
}

.dob-label {
  margin-top: 20px;
}

.quarter-container {
  margin-top: 30px;
  margin-bottom: 50px;
}
.quarter-container .quarter-button-container {
  display: flex;
  justify-content: center;
  margin-top: 10px;
}
.quarter-container .quarter-button-container .quarter-button {
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
}
.quarter-container .quarter-button-container .quarter-button .start-end-dates {
  align-items: center;
  font-size: 0.8rem;
  margin-top: 5px;
}

.top-label {
  color: #19608f;
  font-size: 1.2rem;
  font-weight: 600;
  padding: none;
}

.top-label-secondary-text {
  color: #19608f;
  margin-bottom: 15px;
  font-weight: 500;
}

.disabledColor {
  background: rgb(227, 227, 227);
  opacity: 0.6;
  color: black;
  font-weight: 600;
}

.gutter-80 {
  max-width: 1800px;
  padding: 20px 9px;
  margin: 0 auto;
  width: 80%;
}

.gutter-90 {
  max-width: 1800px;
  padding: 20px 9px;
  margin: 0 auto;
  width: 90%;
}

.gutter-96 {
  max-width: 1800px;
  padding: 20px 9px;
  margin: 0 auto;
  width: 96%;
}

.grade-gutter-90 {
  max-width: 1800px;
  margin: 0 auto;
  width: 90%;
}
.grade-gutter-90 .will-be {
  text-decoration: underline;
}
.grade-gutter-90 .bold {
  font-weight: 650;
}
.grade-gutter-90 .yellow-box {
  border-radius: 4px;
  background: #FEBF31;
  padding: 3px 5px;
  font-weight: 600;
}

.out-of-bounds-container {
  display: flex;
  flex-direction: row;
  height: 500px;
  justify-content: center;
  width: 100%;
}
.out-of-bounds-container .out-of-bounds {
  border-radius: 10px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  align-items: center;
  background: #D1D3D4;
  border: 2px solid #A7A9AC;
  display: flex;
  flex-direction: column;
  height: 50%;
  padding: 50px;
  width: 80%;
}
.out-of-bounds-container hr {
  color: #444343;
  width: 90%;
}

@media only screen and (max-width: 1080px) {
  .action-button-reason {
    font-size: 0.7rem;
    padding: 0px 8px;
  }
}
@media only screen and (max-width: 926px) {
  .action-button-reason {
    font-size: 0.7rem;
    padding: 0px 8px;
  }
}
@media only screen and (max-width: 926px) {
  .action-button-reason {
    font-size: 0.7rem;
    padding: 0px 8px;
  }
}
@media only screen and (max-width: 926px) {
  .action-button-reason {
    font-size: 0.7rem;
    padding: 0px 8px;
  }
}
.entire-webpage {
  zoom: 2;
  -moz-transform: scale(2); /* Firefox Property */
  -moz-transform-origin: 0 0;
  -o-transform: scale(2); /* Opera Property */
  -o-transform-origin: 0 0;
  -webkit-transform: scale(2); /* Safari Property */
  -webkit-transform-origin: 0 0;
  transform: scale(2); /* Standard Property */
  transform-origin: 0 0; /* Standard Property */
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/global/Global.scss","webpack://./src/styles/global/globalMixins.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;AAFA;EACI,gDAAA;AAKJ;;AADA;EACI,mCAAA;AAIJ;;AAFA;EACI,gBAAA;AAKJ;;AAHA;EACI,WAAA;EACA,mBDeK;ECdL,YAAA;AAMJ;;AAJA;EACI,wBAAA;EACA,8BAAA;EACA,gBAAA;EACA,gBAAA;AAOJ;;AALA;EACI,2BAAA;EACA,kBAAA;EACA,mBAAA;AAQJ;AAPI;EACI,iBAAA;EACA,gBAAA;EACA,YAAA;AASR;;AANA;EACI,gBAAA;AASJ;;AAPA;EACI,gBAAA;EACA,mBAAA;AAUJ;AATI;EACI,aAAA;EACA,uBAAA;EACA,gBAAA;AAWR;AAVQ;EACI,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,WAAA;AAYZ;AAXY;EACI,mBAAA;EACA,iBAAA;EACA,eAAA;AAahB;;AANA;EACI,cDtDM;ECuDN,iBAAA;EACA,gBAAA;EACA,aAAA;AASJ;;AAPA;EACI,cD5DM;EC6DN,mBAAA;EACA,gBAAA;AAUJ;;AARA;EACI,8BAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;AAWJ;;AATA;EACI,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,UAAA;AAYJ;;AAVA;EACI,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,UAAA;AAaJ;;AAXA;EACI,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,UAAA;AAcJ;;AAZA;EACI,iBAAA;EACA,cAAA;EACA,UAAA;AAeJ;AAdI;EACI,0BAAA;AAgBR;AAdI;EACI,gBAAA;AAgBR;AAdI;ECtGA,kBDuGuC;EACnC,mBDpFI;ECqFJ,gBAAA;EACA,gBAAA;AAgBR;;AAbA;EACI,aAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,WAAA;AAgBJ;AAfI;ECnHA,mBDoHuC;EC/FvC,2CAAA;EDiGI,mBAAA;EACA,mBDjGA;ECkGA,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,aAAA;EACA,UAAA;AAiBR;AAfI;EACI,cDrGC;ECsGD,UAAA;AAiBR;;AAdA;EACI;IACI,iBAAA;IACA,gBAAA;EAiBN;AACF;AAdA;EACI;IACI,iBAAA;IACA,gBAAA;EAgBN;AACF;AAbA;EACI;IACI,iBAAA;IACA,gBAAA;EAeN;AACF;AAZA;EACI;IACI,iBAAA;IACA,gBAAA;EAcN;AACF;AAXA;EACI,OAAA;EACA,wBAAA,EAAA,qBAAA;EACA,0BAAA;EACA,sBAAA,EAAA,mBAAA;EACA,wBAAA;EACA,2BAAA,EAAA,oBAAA;EACA,6BAAA;EACA,mBAAA,EAAA,sBAAA;EACA,qBAAA,EAAA,sBAAA;AAaJ","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
